import {ImageQueryParams} from 'image-url-utils';

export type ImageMode = 'thumbnail' | 'small-header' | 'header' | 'full';

export const imageModeQueryParams: Record<ImageMode, ImageQueryParams> = {
  'thumbnail': {width: 100, height: 100, fit: 'cover', quality: 50},
  'small-header': {height: 120, quality: 60},
  'header': {width: 500, quality: 50},
  'full': {width: 1080, quality: 90},
};

export const imageModeSizes: Record<ImageMode, string> = {
  'thumbnail': '160px',
  'small-header': '100px',
  'header': '120px',
  'full': '(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 1080px',
};
